var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1SixGroupLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 100,
    viewBox: "0 0 358 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6731_4833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.9306 14.2969C98.1895 5.5561 109.078 0 121.247 0H148.4V20H121.247C115.163 20 109.718 22.7731 106.089 27.1436L57.4697 85.7031C50.2108 94.4439 39.3321 99.9902 27.153 99.9902H0V80H27.153C33.2377 80 38.6722 77.2268 42.3114 72.8564L90.9306 14.2969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.178 0H168.4V100H189.178V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.647 14.2969L283.378 34.4537L300.108 14.2969C307.367 5.5561 318.255 0 330.425 0H357.568V20H330.425C324.34 20 318.896 22.7731 315.267 27.1436L296.285 49.9951L315.267 72.8466C318.896 77.217 324.33 79.9902 330.425 79.9902H357.568V99.9902H330.425C318.255 99.9902 307.367 94.4439 300.108 85.7031L283.378 65.5561L266.647 85.7031C259.388 94.4439 248.5 99.9902 236.331 99.9902H209.178V80H236.331C242.415 80 247.85 77.2268 251.479 72.8564L270.451 50.0049L251.479 27.1436C247.85 22.7731 242.406 20 236.331 20H209.178V0H236.331C248.49 0 259.388 5.5561 266.647 14.2969Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6731_4833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 357.568,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1SixGroupLogo);
export default __webpack_public_path__ + "static/media/1_SIX_Group_logo.32052fdaa765ae550cea87fb84c96562.svg";
export { ForwardRef as ReactComponent };